<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'Settings' | translate }}</ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item-divider color="dark">
      <ion-label>{{ 'Draw' | translate }}</ion-label>
    </ion-item-divider>
    
    <ion-item>
      <ion-toggle helperText="{{'Enter a valid email' | translate}}" [disabled]="authService.authUserSignal().role.value < 400" [checked]="league.settings.draw.enabled" (ionChange)="enableDraw($event)">{{ 'Enable' | translate }}</ion-toggle>
    </ion-item>

    <ion-item-divider color="dark">
      <ion-label>{{ 'Split video board' | translate }}</ion-label>
    </ion-item-divider>

    <form [formGroup]="splitVideoBoardForm">
      <ion-item>
        <ion-toggle formControlName="enabled">{{ 'Enable' | translate }}</ion-toggle><br>
      </ion-item>

      @if (splitVideoBoardForm.get('enabled').value) {
        <ion-item button (click)="!splitVideoBoardForm.get('leftSideTie').value ? findTie('leftSideTie') : removeTie('leftSideTie')">
          <ion-label position="stacked">{{ 'Left scoreboard' | translate }}</ion-label>
          @if (league.settings.splitVideoBoard.leftSideTie) {
            {{ league.settings.splitVideoBoard.leftSideTie?.sides[0]?.team?.name }} - {{ league.settings.splitVideoBoard.leftSideTie?.sides[1]?.team?.name }}
          }
          @if (splitVideoBoardForm.get('leftSideTie').value) {
            <ion-button fill="clear" slot="end">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          }
        </ion-item>

        <ion-item button (click)="!splitVideoBoardForm.get('rightSideTie').value ? findTie('rightSideTie') : removeTie('rightSideTie')">
          <ion-label position="stacked">{{ 'Right scoreboard' | translate }}</ion-label>
          @if (league.settings.splitVideoBoard.rightSideTie) {
            {{ league.settings.splitVideoBoard.rightSideTie?.sides[0]?.team?.name }} - {{ league.settings.splitVideoBoard.rightSideTie?.sides[1]?.team?.name }}
          }
          @if (splitVideoBoardForm.get('rightSideTie').value) {
            <ion-button fill="clear" slot="end">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          }
        </ion-item>
      }
    </form>

    <ion-card color="warning">
      <ion-card-content>
        <ion-text color="dark">
          {{'Features can be enabled only by iOnCourt admin. Please reach out to us at admin&#64;ioncourt.com' | translate}}
        </ion-text>
      </ion-card-content>
    </ion-card>
    
  </ion-list>
</ion-content>